import React, { useState } from 'react';
import { Button } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import { useHistory } from 'react-router-dom';
import DeleteTenantOverrideModal from 'Components/DeleteTenantOverrideModal';
import styles from './TenantOverrideButton.css';

type Props = {
    id: string;
    selectedRowId: string;
    hasOverride?: boolean;
};

const TenantOverrideButton = ({ id, selectedRowId, hasOverride }: Props) => {
    const { t } = useTranslation();
    const history = useHistory();
    const [showModal, setShowModal] = useState(false);

    const closeModal = () => {
        setShowModal(false);
    };

    const onAddOverrideClickOrKeydown = () => {
        history.push(`/global-rules/deployed/landlord/override/add/${id}?selectedRowId=${selectedRowId}`);
    };

    const onEditOverrideClickOrKeydown = () => {
        history.push(`/global-rules/deployed/landlord/override/edit/${id}?selectedRowId=${selectedRowId}`);
    };

    const onRemoveOverrideClickOrKeydown = () => {
        setShowModal(true);
    };

    const AddButton = () => {
        return (
            <Button
                dataTestId='add-tenant-override-button'
                variant='tertiary'
                onClick={handleOnClickEvent(onAddOverrideClickOrKeydown)}
                onKeyDown={handleKeyEvent(onAddOverrideClickOrKeydown)}
            >
                {t('Add Override')}
            </Button>
        );
    };

    const EditButton = () => {
        return (
            <Button
                dataTestId='edit-tenant-override-button'
                variant='tertiary'
                onClick={handleOnClickEvent(onEditOverrideClickOrKeydown)}
                onKeyDown={handleKeyEvent(onEditOverrideClickOrKeydown)}
            >
                {t('Edit Override')}
            </Button>
        );
    };

    const RemoveButton = () => {
        return (
            <Button
                dataTestId='remove-tenant-override-button'
                variant='tertiary'
                onClick={handleOnClickEvent(onRemoveOverrideClickOrKeydown)}
                onKeyDown={handleKeyEvent(onRemoveOverrideClickOrKeydown)}
            >
                {t('Remove Override')}
            </Button>
        );
    };

    return (
        <>
            {hasOverride && (
                <div className={styles.editRemoveButtonContainer}>
                    <DeleteTenantOverrideModal closeModal={closeModal} isOpen={showModal} id={id} />
                    <RemoveButton />
                    <EditButton />
                </div>
            )}
            {!hasOverride && <AddButton />}
        </>
    );
};

export default React.memo(TenantOverrideButton);
